module.exports = __webpack_public_path__ + "img/s4-2.a72a8038.png";